export default __webpack_public_path__ + "static/media/i_bus-noti-running.1b127d9d.svg";